<template lang="pug">
Layout
  template(slot="page")
    Banner
    Features
    Usage
    Functions
    WhatIs
</template>

<script>
import Layout from '../components/layout'
import Banner from '../components/banner'
import Features from '../components/features'
import Usage from '../components/usage'
import Functions from '../components/functions'
import WhatIs from '../components/whatis'

export default {
  name: 'home',
  components: { Layout, Banner, Features, Functions, Usage, WhatIs }
}
</script>



// WEBPACK FOOTER //
// home.vue?0c7ee6f8